import Services from "./Services.jsx";
import IronScrapSection from "./IronScrapSection.jsx";
import AluminiumScrap from "./AluminiumScrap.jsx";
import CarScrap from "./CarScrap.jsx";
import PlasticScrap from "./PlasticScrap.jsx";
import SEO from "../Components/SEO";


function Scrapservices() {
    return(
        <>
        <SEO 
          title="Scrap Recycling Services" 
          description="Explore all our scrap services including Iron, Aluminium, Copper, Car, and Plastic recycling services."
          keywords="scrap recycling services, copper recycling, iron recycling, aluminium scrap, car scrap dealer, plastic scrap recycling"
        />
        <Services/>
        <IronScrapSection/>
        <AluminiumScrap/>
        <CarScrap/>
        <PlasticScrap/>
        </>
    )
}

export default Scrapservices;